<template>
    <div class='login_wrap'>
        <div class="banner_part">
            <img class="login_logo" src="./img/tea_logo.png" alt="">
            <div class="banner_title">同步课堂</div>
            <div class="banner_platform">教师端</div>
        </div>
        <div class="login_form">
            <div class="input_wrap">
                <div class="input_icon account"></div>
                <input ref="phone" v-model="phone" class="input_ele phone" maxlength="11" type="tel" placeholder="请输入账号" />
                <div class="clear_icon" v-show="phone" @click="clearPhone"></div>
            </div>
            <div class="input_wrap">
                <div class="input_icon ver_code"></div>
                <input v-model="code" class="input_ele code_input" maxlength="6" type="tel" placeholder="请输入验证码" />
                <button :disabled="!phone||coding" class='inpu_btn' @click="getCode">{{ coding?second+'s':'获取验证码' }}</button>
            </div>
        </div>
        <button class="login_btn" @click="submit" :disabled="!code||!phone">登录</button>
    </div>
</template>

<script >
    let Base64 = require('js-base64').Base64;
    export default {
        data () {
            return {
                phone: '',
                code: '',
                second:60,
                coding:false,
                timer:null
            }
        },
        methods: {
            clearPhone(){
                this.phone = "";
                this.$refs.phone.focus();
            },
            getCode(){
                    console.log(this.second)
                if (!this.telNumberCheck(this.phone)) {
                    layer.tips("手机号输入不正确");
                    return;
                }
                this.coding = true;
                this.$http.post(API_URL_BASE_API + '/sms/send_code/', {
                    'phone': this.phone,
                    "user_type": 3,
                    'code_type': 12
                }).then(res => {
                    res = res.data;
                    if (res.response === 'ok') {
                        layer.tips("验证码发送成功！");
                    } else {
                        layer.tips(res.message);
                        this.clearFn();
                    }
                })
                this.timer = setInterval(()=> {
                    this.second--;
                    if (this.second == 0) {
                        this.clearFn();
                    }
                }, 1000)
            },
            clearFn() {
                this.coding = false;
                this.second = 60;
                clearInterval(this.timer);
            },
            submit () {//登录
                let vm = this;
                this.$http.post(API_URL_BASE_API + '/account/code/login/', {
                    "phone":Base64.encode(this.phone),
                    "code": this.code,
                    "user_type": 3
                }).then(res => {
                    res = res.data;
                    if (res.response === 'ok') {
                        this.$http.post(API_URL_BASE_API + '/account/add_login/', {//登录埋点
                            "user_type":1,
                            "login_type":6,
                            "platform":7
                        })
                        if (res.data.length) {
                            localStorage.setItem("Tbkt-Token", res.data[0].tbkt_token);
                            this.getProfile();
                        }
                        layer.alert('登录成功！', 'tea', function (index) {
                            vm.$router.push('/');
                            layer.close(index);
                        })
                    } else {
                        layer.alert(res.message);
                    }
                })
            },
            getProfile(){
                this.$http.post(API_URL_BASE_API + '/account/profile/').then((res) => {
                    if (res.data.response === 'ok') {
                        let r = res.data.data;
                        localStorage.setItem('info', JSON.stringify(r));
                        if (r.units.length) {
                            if (r.units[0].city_id == "411600") {
                                localStorage.setItem('city_id', "411600");
                            } else {
                                localStorage.setItem('city_id', "");
                            }
                        }
                    }
                })
            },
            telNumberCheck(tel) {
                var pattern = /^[1][3-9][0-9]{9}$/;
                return pattern.test(tel)
            }
        },
        created () {
        }
    };
</script>
<style rel="stylesheet/scss" lang="scss" scoped>
.login_wrap{
    height: 100vh;
    padding: 0 50px/$ppr;
    background-color: #fff;
    .banner_part{
        text-align: center;
        padding-top: 80px/$ppr;
        .login_logo{
            display: block;
            margin: 0 auto 14px/$ppr;
            width: 120px/$ppr;
            height: 120px/$ppr;
            border: none;
        }
        .banner_title{
            line-height: 54px/$ppr;
            font-size: 36px/$ppr;
            font-weight: bold;
        }
        .banner_platform{
            font-size: 28px/$ppr;
            color: #979fad;
            line-height: 44px/$ppr;
        }
    }
    .login_form{
        padding-top: 82px/$ppr;
        .input_wrap{
            padding: 0 120px/$ppr;
            margin-bottom: 40px/$ppr;
            background-color: #f5f6f9;
            border-radius: 46px/$ppr;
            height: 90px/$ppr;
            position: relative;
            &:last-child{
                margin-bottom: 116px/$ppr;
            }
            .input_icon{
                position: absolute;
                top: 28px/$ppr;
                left: 50px/$ppr;
                background-size: 100% 100%;
                &.account{
                    width: 34px/$ppr;
                    height: 37px/$ppr;
                    background-image: url("./img/img_icon_10.png");
                }
                &.ver_code{
                    width: 33px/$ppr;
                    height: 37px/$ppr;
                    background-image: url("./img/img_icon_11.png");
                }
            }
            .input_ele{
                width: 100%;
                height: 100%;
                display: block;
                background-color: transparent;
                border: none;
                font-size: 30px/$ppr;
                &.code_input{
                    width: 280px/$ppr;
                }
                &::-webkit-input-placeholder{
                    color: #979fad;
                }
            }
            .clear_icon{
                position: absolute;
                top: 27px/$ppr;
                right: 40px/$ppr;
                width: 36px/$ppr;
                height: 36px/$ppr;
                cursor: pointer;
                background-size: 100% 100%;
                background-image: url("./img/img_icon_12.png");
            }
            .inpu_btn{
                color: #2385de;
                position: absolute;
                display: inline-block;
                background-color: transparent;
                border: none;
                height: 90px/$ppr;
                top: 0;
                right: 0;
                width: 226px/$ppr;
                font-size: 30px/$ppr;
                &:disabled{
                    color: #979fad;
                }
            }
        }
    }
    .login_btn{
        display: block;
        width: 100%;
        height: 90px/$ppr;
        background-color: #5e89ef;
        color: #fff;
        font-size: 30px/$ppr;
        border: none;
        border-radius: 46px/$ppr;
        &:disabled{
            background-color: #d2d5df;
        }
    }
}
</style>
